import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Points from '../../../../images/pts-icon.svg';

export const ItemContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0.75rem 0.25rem;
  border-radius: 0.4rem;
  width: 100%;
  position: relative;
  text-align: ${({ textAlignment }) => textAlignment || 'left'};

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    padding: 1rem;
  }

  @media (min-width: 426px) and (max-width: ${themeGet('breakpoints.md')}) {
    width: 75%;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    width: 100%;
  }

  h3 {
    color: ${({ theme, headingColor }) => theme.colors[headingColor]};
    margin: 0;
    line-height: 1.5rem;
    font-size: 1.5rem;
    margin: 0 auto;

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      font-size: 1.2rem;
    }

    span.points {
      font-size: 2.25rem;
      font-weight: 600;
      display: block;
      letter-spacing: -1px;
      margin-top: 0.3rem;

      @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
        margin-top: 0;
        font-size: 1.8rem;
      }

      @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
        font-size: 2rem;
      }

      @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
        font-size: 2.5rem;
      }

      &:after {
        content: '';
        background-image: url(${Points});
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
        position: relative;
        right: 0;
        top: 0;
        height: 1.8rem;
        width: 1.8rem;
        margin-left: 0.2rem;
        display: inline-block;

        @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
          width: 2rem;
          height: 2rem;
        }
      }
    }

    span.esso-red {
      font-size: 1.875rem;
      color: ${themeGet('colors.esso-red')};
      line-height: 3rem;

      @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
        font-size: 2.25rem;
        line-height: 4rem;
      }
    }

    span.normal {
      font-weight: normal;
      font-size: inherit;
      line-height: inherit;
    }
  }
`;

export const ItemHeading = styled.h3`
  width: 80%;
  font-weight: normal;
`;

export const ItemBody = styled.p`
  width: 80%;
  margin-top: 0.5rem;
  font-size: 1rem;
  line-height: 1.5rem;
`;
